import { Card, Group, Stack, Text } from "@mantine/core";
import type { TilesetConfig } from "@project/api";
import type { FC } from "react";
import type { TilesetSource } from "../types/tileset";

interface SourceListProps {
  sources: TilesetSource[];
  config: TilesetConfig;
}

export const SourceList: FC<SourceListProps> = ({ sources }) => {
  return (
    <Stack>
      {sources.map(source => (
        <Card key={source.id} withBorder shadow="sm" radius="md">
          <Group key={source.id}>
            <Text>
              {source.name}
            </Text>
          </Group>
        </Card>
      ))}
    </Stack>
  );
};
